import { Injectable } from '@angular/core';
import { DataRuleId } from '../../data-rules/data-rules-model';
import { IBullhornFieldAndLabel } from '../../datatools-settings/weight-table/weights-interfaces';

@Injectable()
export class UtilsService {

  constructor() {
  }

  openBullhornRecord(id: number, entity: string) {
    console.log(`Opening BH record #${id}`);
    window.open(`https://bullhornstaffing.com/bullhornstaffing/OpenWindow.cfm?entity=${this.getProperEntityName(entity)}&ID=${id}`);
  }

  getPluralEntity(entity: string) {
    switch (entity) {
      case 'Candidate':
        return 'Candidates';
      case 'ClientContact':
        return 'Contacts';
      case 'ClientCorporation':
        return 'Companies';
    }
  }

  /**
   * @param entity e.g. ClientCorporation
   * @return e.g. Company
   */
  getEntityLabel(entity: string): string {
    switch (entity) {
      case 'Candidate':
      case 'candidate':
        return 'Candidate';
      case 'ClientContact':
      case 'clientContact':
        return 'Contact';
      case 'ClientCorporation':
      case 'clientCorporation':
        return 'Company';
    }
  }

  getEntityLower(entity: string): string {
    return this.getEntityLabel(entity).toLowerCase();
  }

  getEntityIcon(entity: string): string {
    switch (entity) {
      case 'clientContact':
        return 'person';
      case  'clientCorporation':
        return 'company';
      default:
        return entity;
    }
  }

  // TODO this will eventually be removed when all references to candidate/contact/company are actually removed from the angular app.
  getProperEntityName(entity: string): string {
    if (!entity) {
      return entity;
    }
    if (entity.includes('candidate') || entity === 'Candidate') {
      return 'Candidate';
    } else if (entity.includes('contact') || entity === 'ClientContact') {
      return 'ClientContact';
    } else if (entity.includes('company') || entity.includes('corporation') || entity === 'ClientCorporation') {
      return 'ClientCorporation';
    }
  }

  getDayStringForDayNumber(dayNumber: number) {
    const days = new Array(7);

    days[1] = 'Monday';
    days[2] = 'Tuesday';
    days[3] = 'Wednesday';
    days[4] = 'Thursday';
    days[5] = 'Friday';
    days[6] = 'Saturday';
    days[7] = 'Sunday';

    return days[dayNumber];
  }

  parseCamelCaseToHyphenDivided(str: string): string {
    const workingArr = str.split('');
    const indexMap = workingArr.reduce((accum, ch, index) => {
      // tslint:disable-next-line:triple-equals
      if (ch == ch.toUpperCase()) {
        accum.push(index);
      }
      return accum;
    }, []);
    return workingArr.map((ch, i) => {
      // tslint:disable-next-line:no-bitwise
      if (~indexMap.indexOf(i)) {
        return `${i > 0 ? '-' : ''}${ch.toLowerCase()}`;
      } else {
        return ch;
      }
    }).join('');
  }

  // TODO refactor the code to use this for every dataRules ids comparison
  compareInternalDataRuleIds(ID_ONE: DataRuleId, ID_TWO: DataRuleId): boolean {
    return `${ID_ONE}` === `${ID_TWO}`;
  }

  /**
   * @param entity hyphen-divided entity name, e.g. 'client-corporation' (see parseCamelCaseToHyphenDivided)
   */
  renderEntityIcon(entity: string): string {
    const defaultName = (() => {
      if (entity.includes('candidate'))
        return 'bhi-candidate';
      if (entity.includes('contact') || entity.includes('person'))
        return 'bhi-person';
      if (entity.includes('client-corporation'))
        return 'bhi-company';
      if (entity.includes('submission'))
        return 'bhi-job submission';
      if (entity.includes('job'))
        return 'bhi-job';
      if (entity.includes('lead'))
        return 'bhi-lead';
      if (entity.includes('opportunity'))
        return 'bhi-opportunity';
      if (entity.includes('placement'))
        return 'bhi-star';
      if (entity.includes('appointment'))
        return 'bhi-appointment';
      if (entity.includes('task'))
        return 'bhi-check-o';
      if (entity.includes('note'))
        return 'bhi-add-note';
      if (entity.includes('sendout'))
        return 'bhi-email';
      if (entity.includes('tearsheet'))
        return 'bhi-tearsheet';
      return 'bhi-puzzle';
    })();
    return entity.includes('custom-object') ? `${defaultName} custom-object` : defaultName;
  }
}
